import { useEffect, useRef, useState } from 'react';

const MAX_STEP_MS = 60;
const MAX_DURATION_MS = 400;
const MAX_STEPS = 15;

export const useAnimatedCount = (target: number | undefined): number | undefined => {
    const [displayed, setDisplayed] = useState<number | undefined>(target);
    const displayedRef = useRef<number | undefined>(target);

    useEffect(() => {
        if (target === undefined || target === displayedRef.current) return;

        const from = displayedRef.current ?? target;
        const gap = target - from;
        const steps = Math.min(Math.abs(gap), MAX_STEPS);
        const stride = gap / steps;
        const stepMs = Math.min(MAX_STEP_MS, Math.floor(MAX_DURATION_MS / steps));
        let step = 0;

        const interval = setInterval(() => {
            step += 1;
            const next = step >= steps ? target : Math.round(from + stride * step);
            displayedRef.current = next;
            setDisplayed(next);
            if (step >= steps) clearInterval(interval);
        }, stepMs);

        return () => clearInterval(interval);
    }, [target]);

    return displayed;
};
